// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"739":"5a29b642","1996":"bf461347","5251":"89efb31a","7963":"035d90fd","8442":"4612b538"}[chunkId] + ".chunk.css";
};